import React, { useEffect, useRef, useMemo } from 'react'
import { TeaserData } from './teaser'
import { TeaserEntry } from '../helper/interfaces';
import { useLoggedRouter } from '../helper/useLoggedRouter';
import { logBugsnagError } from '../lib/bugsnag';

export default function TeaserFreeHtml(data: TeaserData) {
  const teaser = data.teaser as TeaserEntry;
  const teaserRef = useRef<HTMLDivElement>(null);
  const [routerPush, routerReplace] = useLoggedRouter(); 

  const htmlSnippet = useMemo(() => {
    if(teaser?.body?.includes('tickaroo-liveblog-teaser') && (teaser?.body?.includes('liveblogUrl') || teaser?.body?.includes('liveblogurl'))) {
      try {
        const liveblogUrl = teaser.body.match(/liveblogUrl="([^"]+)"/)?.[1] || teaser.body.match(/liveblogurl="([^"]+)"/)?.[1];
        const regex = /http.*[-\/](\d[.]\d*)/i;
        const found = liveblogUrl?.match(regex)
        
        let liveblogId: string | undefined = undefined
        if(found?.length == 2) {
          liveblogId = found[1]
        }
        const newLeblogUrl = `${process.env.NEXT_PUBLIC_BACKEND_URL}/article/${liveblogId}`;
        const newBody = teaser.body.replace(liveblogUrl ?? '', newLeblogUrl);
        return newBody;
      } catch (error) {
        logBugsnagError(error as Error, (event) => {
          event.addMetadata('teaser', { teaser: teaser });
        });
        return null  
      }
      
    }
    else {
      return teaser?.body;
    }
  }, [teaser]);

  const navigateToArticle = async (e: MouseEvent) => {
    let target = (e.target as HTMLElement).closest('a') as HTMLAnchorElement;
      
    if(target) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      
      // replace existing article hash param if it exists
      const newUrl = new URL(window.location.href);
      newUrl.hash = `a=${teaser.id}`;
      
      await routerReplace(newUrl.toString());
      await routerPush(target.href);

      // await routerPush(target.href.replace("/localhost/", "/localhost:3000/"))
    }
  }

  useEffect(() => {
    if(teaser?.body?.includes('tickaroo-liveblog-teaser')) {
      const captureTarget = teaserRef.current;
      if(captureTarget) {
        captureTarget.addEventListener("click", function(e: MouseEvent) {
          navigateToArticle(e);
        })
      }
      else {
        console.log("no capture target found")
      }
    }
  }, [teaser]);
  
  return <React.Fragment>
    <div id="tickaroo-liveblog-teaser" className="" ref={teaserRef} data-name={`article-${teaser.id}`}>
      {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}
      <div className="infobox__body teaser-free-html">
         {htmlSnippet && 
          <div dangerouslySetInnerHTML={{ __html: htmlSnippet }} />
         }
      </div>
    </div>
  </React.Fragment>
}